export const normalizeCategoryData = (data: any) => {
    return data?.TechMapCategories?.items || [];
};
